// import axios from 'axios';
import types from '../../mutation-types';
import ChatbotAPI from '../../../api/chatbot';
import KeystoneAPI from '../../../api/keystone';
import { AI_SUGGEST_PROVIDER } from '../../../mixins/aiSuggestOptionsMixin';

// TODO Set right UI flags

const SUGGESTION_FAILED_TIMEOUT = 5000;

export const actions = {
  setUiFlag: ({ commit }, newFlags) => {
    try {
      commit(types.SET_MESSAGE_TEMPLATE_UI_FLAGS, newFlags);
    } catch (error) {
      // TODO some action
    }
  },

  getHandover: async ({ commit }, { accountId, userId, botId, inboxId }) => {
    let result = true;

    try {
      commit(types.SET_CHATBOT_UI_FLAGS, { isFetching: true });
      commit(types.CLEAR_CHATBOT_HANDOVER);

      const { data } = await ChatbotAPI.getHandover(
        accountId,
        userId,
        botId,
        inboxId
      );

      if (!data?.success || !data?.data) {
        throw new Error();
      }

      commit(types.SET_CHATBOT_HANDOVER, data.data);
    } catch (error) {
      result = false;
    } finally {
      commit(types.SET_CHATBOT_UI_FLAGS, { isFetching: false });
    }

    return result;
  },

  updateHandover: async (
    { commit },
    { accountId, handover, updateStoreValue = false }
  ) => {
    let result = true;

    try {
      commit(types.SET_CHATBOT_UI_FLAGS, { isUpdating: true });

      const { data } = await ChatbotAPI.updateHandover(accountId, handover);

      if (!data?.success || !data?.data) {
        throw new Error();
      }

      if (updateStoreValue) {
        commit(types.SET_CHATBOT_HANDOVER, data.data);
      }
    } catch (error) {
      result = false;
    } finally {
      commit(types.SET_CHATBOT_UI_FLAGS, { isUpdating: false });
    }

    return result;
  },

  addHandoverTranslations: async (
    { commit },
    { accountId, handoverId, translations, updateStoreValue = false }
  ) => {
    let result = true;

    try {
      commit(types.SET_CHATBOT_UI_FLAGS, { isTranslationsAdding: true });

      const { data } = await ChatbotAPI.addHandoverTranslations(
        accountId,
        handoverId,
        translations
      );

      if (!data?.success || !data?.data) {
        throw new Error();
      }

      if (updateStoreValue) {
        commit(types.SET_CHATBOT_HANDOVER, data.data);
      }
    } catch (error) {
      result = false;
    } finally {
      commit(types.SET_CHATBOT_UI_FLAGS, { isTranslationsAdding: false });
    }

    return result;
  },

  deleteHandoverTranslation: async (
    { commit, rootGetters },
    { accountId, translationId, updateStoreValue }
  ) => {
    let result = true;

    try {
      commit(types.SET_CHATBOT_UI_FLAGS, { isTranslationsDeleting: true });

      const { data } = await ChatbotAPI.deleteHandoverTranslation(
        accountId,
        translationId
      );

      if (!data?.success) {
        throw new Error();
      }

      if (updateStoreValue) {
        const newHandover = structuredClone(rootGetters['chatbot/getHandover']);

        commit(types.SET_CHATBOT_HANDOVER, {
          ...newHandover,
          translations: newHandover.translations.filter(
            (translation) => translation.id !== translationId
          ),
        });
      }
    } catch (error) {
      result = false;
    } finally {
      commit(types.SET_CHATBOT_UI_FLAGS, { isTranslationsDeleting: false });
    }

    return result;
  },

  getConversationStatus: async ({ commit }, { accountId, conversationId }) => {
    let result = true;

    try {
      commit(types.SET_CHATBOT_UI_FLAGS, {
        isConversationStatusFetching: true,
      });

      commit(types.CLEAT_CHATBOT_CONVERSATION_STATUS);

      const { data } = await ChatbotAPI.getConversationStatus(
        accountId,
        conversationId
      );
      const isAIEnabled = data.conversation_state === 'ai';

      commit(types.SET_CHATBOT_CONVERSATION_STATUS, data);

      commit(types.SET_CHATBOT_CONVERSATIONS_STATUSES_STATE, {
        id: conversationId,
        updatedKeys: { isAIEnabled, successful: data.successful },
      });
    } catch (error) {
      result = false;
    } finally {
      commit(types.SET_CHATBOT_UI_FLAGS, {
        isConversationStatusFetching: false,
      });
    }

    return result;
  },

  updateConversationStatus: async (
    { commit },
    { accountId, conversationId, state }
  ) => {
    let result = true;

    try {
      commit(types.SET_CHATBOT_UI_FLAGS, {
        isConversationStatusUpdating: true,
      });
      // commit(types.CLEAT_CHATBOT_CONVERSATION_STATUS);
      const { data } = await ChatbotAPI.updateConversationStatus(
        accountId,
        conversationId,
        state
      );
      commit(types.SET_CHATBOT_CONVERSATION_STATUS, data);
      const isAIEnabled = data.conversation_state === 'ai';

      commit(types.SET_CHATBOT_CONVERSATIONS_STATUSES_STATE, {
        id: conversationId,
        updatedKeys: { isAIEnabled, successful: data.successful },
      });
    } catch (error) {
      result = false;
    } finally {
      commit(types.SET_CHATBOT_UI_FLAGS, {
        isConversationStatusUpdating: false,
      });
    }

    return result;
  },

  getAINests: async ({ commit }, { accountId }) => {
    let result = true;

    try {
      commit(types.SET_CHATBOT_UI_FLAGS, {
        isAINestLoading: true,
      });

      commit(types.CLEAR_CHATBOT_AI_NESTS);

      const { data } = await ChatbotAPI.getAINests(accountId);

      commit(types.SET_CHATBOT_AI_NESTS, data);
    } catch (error) {
      result = false;
    } finally {
      commit(types.SET_CHATBOT_UI_FLAGS, {
        isAINestLoading: false,
      });
    }

    return result;
  },

  getAiSuggestions: async ({ commit }, { provider, executeId, payload }) => {
    let result = true;

    try {
      commit(types.SET_CHATBOT_UI_FLAGS, {
        isAISuggestionLoading: true,
        isAISuggestionFailed: false,
      });

      commit(types.CLEAR_CHATBOT_AI_SUGGESTIONS);

      let response;
      let suggestions;

      switch (provider) {
        case AI_SUGGEST_PROVIDER.KEYSTONE: {
          response = await KeystoneAPI.getSuggestions(executeId, payload);

          const templateData = response?.data?.templates[0]?.templateData;

          suggestions = [
            {
              answer: response?.data?.response,
              language: templateData?.language ?? 'en',
              translatedAnswer: templateData?.translation,
            },
          ];
          break;
        }

        case AI_SUGGEST_PROVIDER.CHATBOT: {
          response = await ChatbotAPI.getAISuggestions({
            nestId: executeId,
            ...payload,
          });

          suggestions = response?.data;
          break;
        }
        default: {
          throw new Error('Unsupported AI provider');
        }
      }

      if (!response.data || !suggestions?.length) {
        throw new Error('No data received from AI provider');
      }

      commit(types.SET_CHATBOT_AI_SUGGESTIONS, suggestions);
    } catch (error) {
      result = false;
      commit(types.SET_CHATBOT_UI_FLAGS, {
        isAISuggestionFailed: true,
      });

      setTimeout(() => {
        commit(types.SET_CHATBOT_UI_FLAGS, {
          isAISuggestionFailed: false,
        });
      }, SUGGESTION_FAILED_TIMEOUT);
    } finally {
      commit(types.SET_CHATBOT_UI_FLAGS, {
        isAISuggestionLoading: false,
      });
    }

    return result;
  },

  clearAllAISuggestionsData: ({ commit }) => {
    try {
      commit(types.SET_CHATBOT_UI_FLAGS, {
        isAISuggestionLoading: false,
        isAISuggestionFailed: false,
      });

      commit(types.CLEAR_CHATBOT_AI_SUGGESTIONS);
    } catch (error) {
      // TODO some action
    }
  },

  setConversationsStatuses: ({ commit }, payload) => {
    commit(types.SET_CHATBOT_CONVERSATIONS_STATUSES_STATE, payload);
  },

  getAIImprovement: async ({ commit }, payload) => {
    let result = true;

    try {
      commit(types.SET_CHATBOT_UI_FLAGS, {
        isAIImprovementLoading: true,
        isAIImprovementFailed: false,
      });

      commit(types.CLEAR_CHATBOT_AI_IMPROVEMENT);

      const { data } = await ChatbotAPI.getAIImprovement(payload);

      commit(types.SET_CHATBOT_AI_IMPROVEMENT, JSON.parse(data.result));
    } catch (error) {
      result = false;
      commit(types.SET_CHATBOT_UI_FLAGS, {
        isAIImprovementFailed: true,
      });

      setTimeout(() => {
        commit(types.SET_CHATBOT_UI_FLAGS, {
          isAIImprovementFailed: false,
        });
      }, 5000);
    } finally {
      commit(types.SET_CHATBOT_UI_FLAGS, {
        isAIImprovementLoading: false,
      });
    }

    return result;
  },

  clearAllAIImprovementData: async ({ commit }) => {
    try {
      commit(types.SET_CHATBOT_UI_FLAGS, {
        isAIImprovementLoading: false,
        isAIImprovementFailed: false,
      });

      commit(types.CLEAR_CHATBOT_AI_IMPROVEMENT);
    } catch (error) {
      // TODO some action
    }
  },
};
